import { townsperson } from './content.js';
import { SWAMP_DEPTHS_QUESTS } from './swamp-depths.js';
import { SWAMP_DRAGON_QUESTS } from './swamp-dragon.js';
import { SWAMP_VILLAGE_QUESTS } from './swamp-village.js';
/**
 * The quests of the Marais Brumeux (ADR 0047): the chain that starts with
 * la Doyenne Ombeline (`swamp-elder`), on Brumevase's square, and follows
 * the mist from the cemetery to the ruins and the troll's bog, then south
 * to Sablerouge; the townsfolk it needs, its two baits, and the experience
 * of its creatures once the chain pays the rest. See `content.ts`.
 */
/** The townsfolk only this region's quests need, added to the bestiary. */
export const SWAMP_NPC_IDS = [
    'swamp-elder',
    'swamp-ferryman',
    'swamp-gravedigger',
    'swamp-scholar',
    'swamp-hunter',
];
export const SWAMP = {
    // The dragon’s branch before the road south, so the chain still ends on its hand-over.
    quests: [
        ...SWAMP_VILLAGE_QUESTS,
        ...SWAMP_DEPTHS_QUESTS.slice(0, -1),
        ...SWAMP_DRAGON_QUESTS,
        ...SWAMP_DEPTHS_QUESTS.slice(-1),
    ],
    npcs: {
        'swamp-elder': townsperson('swamp-elder', 'Doyenne Ombeline'),
        'swamp-ferryman': townsperson('swamp-ferryman', 'Passeur Ansgar'),
        'swamp-gravedigger': townsperson('swamp-gravedigger', 'Fossoyeuse Guénola'),
        'swamp-scholar': townsperson('swamp-scholar', 'Érudit Théophane'),
        'swamp-hunter': townsperson('swamp-hunter', 'Traqueuse Nella'),
    },
    // The elder stands on the square by the generator (`questGiver`); the
    // others by the places their quests send the player to.
    keepers: [
        { mob: 'swamp-ferryman', near: 'Brumevase', dx: 0, dy: -14, facing: 'south' },
        { mob: 'swamp-gravedigger', near: 'Cimetière Englouti', dx: 0, dy: 5, facing: 'south' },
        { mob: 'swamp-scholar', near: 'Ruines Noyées', dx: -4, dy: 5, facing: 'south' },
        { mob: 'swamp-hunter', near: 'Brumevase', dx: 0, dy: 15, facing: 'south' },
        // Each player's own quarry where no den lies near (ADR 0087).
        {
            mob: 'lizardman',
            near: 'Bourbier du Troll',
            dx: -3,
            dy: 0,
            count: 5,
            radius: 4,
            during: 'swamp-bog',
        },
        {
            mob: 'caiman',
            near: 'Bourbier du Troll',
            dx: 3,
            dy: 0,
            count: 4,
            radius: 4,
            during: 'swamp-bog',
        },
        {
            mob: 'caiman-maddened',
            near: 'L’Empreinte',
            dx: 0,
            dy: 0,
            count: 4,
            radius: 5,
            during: 'swamp-dragon-print',
        },
    ],
    items: [
        {
            id: 'peat-worm',
            name: 'Ver de tourbe',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.peat-worm',
            lootable: false,
            bait: { summons: 'venom-toad', den: 'toad' },
        },
        {
            id: 'scale-idol',
            name: 'Idole d’écailles',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.scale-idol',
            lootable: false,
            bait: { summons: 'lizard-shaman', den: 'lizardman' },
        },
        {
            id: 'black-lotus',
            name: 'Lotus noir',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.black-lotus',
            lootable: false,
            bait: { summons: 'bog-king', den: 'toad' },
        },
    ],
    // Nearly half of the band is paid by the chain (the meadow's is a third):
    // its creatures pay about half what they did (toad 40, lizardman 50, caiman
    // 55), so the region lasts a little longer with the chain than it did by
    // the hunt alone (`pnpm audit:pacing swamp`, ADR 0047). The elites follow.
    xp: { toad: 19, wisp: 22, lizardman: 23, caiman: 26 },
    greetings: {
        'swamp-elder': 'Approche, je ne te vois pas bien. Voilà, c’est mieux !',
        'swamp-ferryman': 'Ma barque flotte. C’est déjà ça.',
        'swamp-gravedigger': 'Troisième rangée, c’est le gardien. Passe lui dire bonjour, il n’a jamais de visite.',
        'swamp-scholar': 'Quatre cent treize ! J’ai trouvé une nouvelle spirale ce matin. Tu veux voir ? Non ? Bon.',
        'swamp-hunter': 'Tu marches toujours trop fort. Les caïmans t’entendent arriver de loin !',
    },
};
//# sourceMappingURL=swamp.js.map